"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewModel = void 0;
class ReviewModel {
    constructor(obj = null) {
        this.id = -1;
        this.author = "";
        this.date = new Date();
        this.score = 0;
        this.reviewTitle = "";
        this.reviewContent = "";
        this.refCourseCode = "";
        this.courseType = "";
        this.courseTitle = "";
        this.courseUrl = "";
        this.totalReviews = 0;
        this.trustScore = 0;
        if (obj != null) {
            this.clone(obj);
        }
    }
    clone(obj) {
        this.id = obj.id;
        this.author = obj.author;
        this.date = new Date(Date.parse(obj.date.toString()));
        this.score = obj.score;
        this.reviewTitle = obj.reviewTitle;
        this.reviewContent = obj.reviewContent;
        this.refCourseCode = obj.refCourseCode;
        this.courseType = obj.courseType;
        this.courseTitle = obj.courseTitle;
        this.courseUrl = obj.courseUrl;
        this.totalReviews = obj.totalReviews;
        this.trustScore = obj.trustScore;
    }
    static fromJSON(d) {
        const review = Object.assign(new ReviewModel(), typeof d === 'string' ? JSON.parse(d) : d);
        return review;
    }
}
exports.ReviewModel = ReviewModel;
//# sourceMappingURL=review.model.js.map